// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Multiplexing mode for a channel.
 * LOAD_BALANCE is schema-reserved; not implemented in v1.
 */
export enum ChannelMode {
  SINGLE = 0,
  FAILOVER = 1,
  MERGE = 2,
  MIXED = 3,
  LOAD_BALANCE = 4,

  /**
   * One transport carrying several adapters at once — the DUAL of the four
   * values above it. Those multiplex ENDPOINTS: many transports collapse
   * into one logical channel. This one multiplexes ADAPTERS: a single
   * connection is demultiplexed to whichever participant's offset map claims
   * the incoming address.
   *
   * Two LN1 adapters can therefore split one controller bus, either by board
   * range or by interleaved gaps inside a shared range. Participants are the
   * channel's banks, each carrying its own `adapter_id`, so this needs no
   * join table: `banks.channel_id` and `banks.adapter_id` already express it.
   *
   * Mutually exclusive with `Channel.routable`, which demultiplexes one
   * socket to N banks of ONE adapter by `banks.logical_port`. Both want to
   * own inbound dispatch on a connection, so a channel asserting both is a
   * configuration error rather than a combination.
   */
  CO_RESIDENT = 5,
}
